import * as environment from '../config/environment';
import { BaseAPI } from './BaseAPI';

class WebSabitlerAPI extends BaseAPI {

  constructor() {
    const baseUrl = environment.API_URL + "WebSabitler";
    super(baseUrl);
  }

  getWebSabitler() {
    return this.get()
  }

}
export default new WebSabitlerAPI();
